export default __webpack_public_path__ + "static/media/2328.cd690ddd.png";